import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { Spin, Row, Col, Button, Input, Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import util from '../../util/util'
import { Surgeon } from '../../component'
import '../../css/surgeon.scss'
import {
  fetchSurgeons,
  setSelectedSurgeons,
  removeSurgeons,
} from '../../store/action/surgeon.action'
import serviceInterface from '../../services/service.interface'
import { constants } from '../../constants'
import { messageGroupBy } from '../../store/action/actioncases.action'
import { useEffect } from 'react'
import { getHelp, pages } from '../../tutorials'
var { ROLE } = constants

const ONLY_ADMINS = [
  ROLE.ADMIN,
  ROLE.COMPANY_ADMIN,
  ROLE.COMPANY_HEALTHCOACH,
  ROLE.SUPER_ADMIN,
]

var { Search } = Input
var { Table } = Surgeon

const Surgeons = (props) => {
  var handleSearch = (value) => {
    props.setSelectedSurgeons([])
    props.fetchSurgeons({
      customerid: props.customer?._id,
      pagination: { current: 1, pageSize: 20 },
      searchText: value,
      sorter: { order: 'ascend', field: 'surgery' },
    })
  }
  useEffect(() => {
    props.messageGroupBy(null)
    getHelp(pages.SURGEONPAGE)
  }, [])
  var surgeonsList = (
    <Col>
      <Row>
        <h3>Are you sure you want to delete all the selected providers ?</h3>
      </Row>
      {props.selectedSurgeons?.map((surgeon) => (
        <Row>
          {surgeon?.name}&nbsp;({surgeon?.accesscode})
        </Row>
      ))}
    </Col>
  )

  var deleteSurgeons = async () => {
    var response = await props.deleteSurgeons(
      props.selectedSurgeons.map((e) => e._id)
    )
    response &&
      props.fetchSurgeons({
        customerid: props.customer?._id,
        pagination: { ...props.pagination, current: 1 },
        searchText: props.searchText,
        sorter: props.sorter,
      })
    response && props.setSelectedSurgeons([])
  }

  var handleDelete = () => {
    if (props.selectedSurgeons.length == 0) return
    Modal.confirm({
      className: 'confirm-modal',
      title: 'Confirm',
      icon: <ExclamationCircleOutlined />,
      content: surgeonsList,
      okText: 'Delete',
      cancelText: 'Cancel',
      onOk: deleteSurgeons,
    })
  }

  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <>
      <Spin spinning={props.isLoading}>
        <Col className='surgeon-container'>
          <Row className={'actionRow'}>
            <Col flex={'60%'}>
              <Row className={'headerText'} gutter={20} align={'middle'}>
                <Col flex={'40px'}> PROVIDERS </Col>
                <Col flex={'auto'} id={'surgeonsearch'}>
                  <Search
                    placeholder='name/email/phone'
                    className='surgeonSearch'
                    onSearch={handleSearch}
                    defaultValue={props.searchText}
                  />
                </Col>
              </Row>
            </Col>
            <Col style={{ alignSelf: 'flex-end' }} flex={'auto'}>
              <Row justify={'end'} align={'bottom'}>
                {serviceInterface
                  .AuthService()
                  .authorize_role(ONLY_ADMINS, props?.decoded) && (
                  <Button
                    id={'sugeondelete'}
                    onClick={handleDelete}
                    className={'actionBtn'}
                  >
                    DELETE
                    {props.selectedSurgeons?.length > 0 &&
                      '  (' + props.selectedSurgeons?.length + ')'}
                  </Button>
                )}
              </Row>
            </Col>
            <Col
              id={'sugeonadd'}
              style={{ alignSelf: 'flex-end', marginLeft: 20 }}
            >
              <Row justify={'end'} align={'bottom'}>
                {serviceInterface
                  .AuthService()
                  .authorize_role(ONLY_ADMINS, props?.decoded) && (
                  <Button className={'actionBtn'}>
                    <Link to='/surgeons/add'> ADD </Link>
                  </Button>
                )}
              </Row>
            </Col>
          </Row>
          <Table />
        </Col>
      </Spin>
    </>
  )
}

Surgeons.propTypes = {
  isLoading: PropTypes.bool,
  token: PropTypes.string.isRequired,
  deleteSurgeons: PropTypes.func.isRequired,
  pagination: PropTypes.object,
  sorter: PropTypes.object,
  searchText: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    decoded: util.verifyToken(state.profile.token, true),
    isLoading: state.profile.isLoading,
    customer: state.profile.customer,
    successMessage: state.profile.successMessage,
    selectedSurgeons: state.surgeon.selectedSurgeons,
    pagination: state.surgeon.pagination,
    searchText: state.surgeon.searchText,
    sorter: state.surgeon.sorter,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSurgeons: (params) => dispatch(fetchSurgeons(params)),
    setSelectedSurgeons: (surgeons) => dispatch(setSelectedSurgeons(surgeons)),
    messageGroupBy: (data) => dispatch(messageGroupBy(data)),
    deleteSurgeons: (params) => dispatch(removeSurgeons(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Surgeons)
